import React, {useState} from "react";
import {auth} from "../../../firebase";
import {validateEmail} from "../../../utils/utils";
import {toast} from "react-toastify";

type Props = {
    setCurrentPage: (page: string) => void;
}

function ForgotPassword({setCurrentPage}: Props) {

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [showDisableButton, setShowDisableButton] = useState(false);

    const enableUser = (e: any) => {
        e.preventDefault();
        dismissError();
    }

    const loginUser = async (e: any) => {
        e.preventDefault();
        dismissError();
        if(validateEmail(email)){
            await auth.sendPasswordResetEmail(email).then(() => {
                toast.info(
                    <div>
                        Se ha enviado un correo electrónico para restablecer la contraseña
                    </div>
                )
                setCurrentPage("login");
            }).catch(error => {
                if(error.message.includes('(auth/user-not-found)')){
                    toast.error(
                        <div>
                            No existe un usuario con este correo electrónico
                        </div>
                    )
                }
            })

        } else{
            toast.error(
                <div>
                    El correo electrónico no es válido
                </div>
            )
        }
    }

    function dismissError(){
        setError("");
        document.getElementById("loginHomeModal")?.querySelectorAll('input').forEach(x => x.classList.remove('is-invalid'))
    }

    const colSize = "col-12";

    return (
        <div className="col-12">
            <form className="d-flex flex-row flex-wrap col-12 justify-content-center">
                <div className={colSize}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                {error && <div className="alert alert-danger alert-dismissible fade show col-7" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => dismissError()}/>
                </div>}

                <div className={"form-floating mb-3 " + colSize}>
                    <input value={email} onChange={e => {
                        setEmail(e.target.value);
                        setShowDisableButton(false);
                    }}
                           type="email" className="form-control" id="floatingInput" placeholder="Correo electrónico"/>
                    <label htmlFor="floatingInput">Email</label>
                </div>
                <div className={colSize + " mb-3 d-flex flex-row justify-content-between"}>
                    {!showDisableButton && <button className="btn btn-primary" type="submit" onClick={e => {
                        loginUser(e);
                    }}>Enviar</button>}
                </div>
                <div className={colSize + " mb-3"}>
                    <b>¿No tienes una cuenta?</b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}}  onClick={() => setCurrentPage("signUp")}>
                        Regístrate
                    </a>
                </div>
                <div className={"mb-3 " + colSize}>
                    <b>¿Tienes ya una cuenta?</b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}} onClick={() => setCurrentPage("login")}>
                        Inicia sesión
                    </a>
                </div>
            </form>
        </div>
    )
}

export default ForgotPassword;
